if (!window.reaLoadMoreInit) {
  window.reaLoadMoreInit = true;

  const bindButton = (button) => {
    if (button.dataset.reaLoadMoreBound) return;
    button.dataset.reaLoadMoreBound = 'true';

    button.addEventListener('click', async () => {
      const nextUrl = button.dataset.nextUrl;
      const wrapper = button.closest('.pagination-wrapper--load-more');
      const sectionId = wrapper?.dataset.sectionId;
      const grid = document.getElementById('product-grid');
      const spinner = button.querySelector('.loading__spinner');
      if (!nextUrl || !sectionId || !grid) return;

      button.setAttribute('disabled', 'disabled');
      spinner?.classList.remove('hidden');

      try {
        const url = new URL(nextUrl, window.location.origin);
        url.searchParams.set('section_id', sectionId);
        const response = await fetch(url.toString());
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newGrid = doc.getElementById('product-grid');
        if (newGrid) {
          Array.from(newGrid.children).forEach((child) => grid.appendChild(child));
        }

        const newButton = doc.querySelector('.rea-load-more__button');
        if (newButton && newButton.dataset.nextUrl) {
          button.dataset.nextUrl = newButton.dataset.nextUrl;
          button.removeAttribute('disabled');
          spinner?.classList.add('hidden');
        } else {
          wrapper.remove();
        }
      } catch (error) {
        button.removeAttribute('disabled');
        spinner?.classList.add('hidden');
      }
    });
  };

  const initLoadMore = () => {
    document.querySelectorAll('.rea-load-more__button').forEach(bindButton);
  };

  initLoadMore();
  document.addEventListener('shopify:section:load', initLoadMore);
}
